// components/SearchAdvance.js
const SearchAdvance = ({ showFields, toggleShowFields }) => {
  return (
    <button
      onClick={toggleShowFields}
      className="px-3 py-2 text-sm text-white bg-green-600 rounded shadow hover:bg-green-700"
    >
      {showFields ? 'Hide Advanced Search' : 'Advanced Search'}
    </button>
  );
};

export default SearchAdvance;
